import React, { useState, useEffect } from 'react';
import Menu from '../Menu'
import '../App.css'


const ReportMySharesSymb = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    // Sort data based on sortConfig
    const sortedData = [...data].sort((a, b) => {
        if (!sortConfig.key) return 0;

        // Handle string sorting for symb
        if (sortConfig.key === 'symb') {
            const aValue = (a[sortConfig.key] || '').toLowerCase();
            const bValue = (b[sortConfig.key] || '').toLowerCase();
            if (sortConfig.direction === 'asc') {
                return aValue.localeCompare(bValue);
            } else {
                return bValue.localeCompare(aValue);
            }
        }

        // Handle numeric sorting for amount, procent
        const aValue = parseFloat(a[sortConfig.key]) || 0;
        const bValue = parseFloat(b[sortConfig.key]) || 0;

        if (sortConfig.direction === 'asc') {
            return aValue - bValue;
        } else {
            return bValue - aValue;
        }
    });

    // Handle column header click for sorting
    const handleSort = (key) => {
        console.log('Sorting by:', key);
        setSortConfig((prevConfig) => {
            const newConfig = {
                key,
                direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc'
            };
            console.log('New sort config:', newConfig);
            return newConfig;
        });
    };

    // Get CSS class for sortable column header
    const getSortClass = (key) => {
        let className = 'sortable';
        if (sortConfig.key === key) {
            className += ' ' + sortConfig.direction;
        }
        return className;
    };

    useEffect(() => {
        // Replace with your API endpoint
        

        const mytoken=sessionStorage.getItem('google_token');
        const apiUrl = 'https://app64.heliohost.us/api/getreports.php?oper=share_symb';
        //const apiUrl = 'http://localhost/api/getShareAlarms.php';

        
        fetch( apiUrl,{
            method:"GET",          
            headers:{
                "Content-Type": "application/json",
                "AuthCode" : mytoken
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                return response.json();
            })
            .then((data) => {
                setData(data);
                setLoading(false);
                //const totalSum = data.reduce((sum, item) => sum + 1*item.amounteuro, 0);                
                //setSum(totalSum.toFixed(2));

            })
            .catch((error) => {
                console.error("Error:", error);
                setError(error.message);
                setLoading(false);
            });
    }, []); // Empty dependency array means this runs once on component mount

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error}</p>;
    }

    return (
        <div>
            <Menu/>
            <h1 className="page-title">Shares by Symbol</h1>
            <div className="table-container">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th onClick={() => handleSort('symb')} className={getSortClass('symb')}>Symbol</th>
                            <th onClick={() => handleSort('amount')} className={getSortClass('amount')}>Amount</th>
                            <th>Currency</th>
                            <th>Val Now</th>
                            <th>Val Inv</th>
                            <th>Search</th>
                            <th>Val Alarm</th>
                            <th onClick={() => handleSort('procent')} className={getSortClass('procent')}>%</th>
                            <th>Config</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData.map((item, index) => (
                            <tr key={`${item.symb}-${index}`}>
                                <td>{item.symb}</td>
                                <td>{item.amount}</td>
                                <td>{item.currency}</td>
                                <td>{item.valnow}</td>
                                <td>{item.valinvact}</td>
                                <td>{item.valalarm}</td>
                                <td>{item.idsearch}</td>
                                <td>{item.procent}</td>
                                <td><a href={`/sharealarmedit/${item.idsearch}`}>{item.idsearch}</a></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};


export default ReportMySharesSymb